import { logger } from '@modules/logger';
import { createContext, useContext } from 'react';

import type { Notification } from 'types';

const initialContext = {
  notifications: undefined,
  notify: () => logger.warn('notify not provided for notificationContext'),
  hideNotification: () => logger.warn('hideNotification not provided for notificationContext'),
};

interface NotificationContextValues {
  notifications?: Notification[];
  notify: (notification: Notification) => void;
  hideNotification: (notification: Notification) => void;
}

const notificationContext = createContext<NotificationContextValues>(initialContext);

const useNotificationContext = () => useContext(notificationContext);

export { notificationContext, useNotificationContext };
